export { t, locale, I18nProvider, useI18n } from '../app/i18n';
